import { Link } from 'react-router-dom';

import { FrequentPassageRequest } from '@legacy-types';

import { useEvent } from '@legacy-providers/event';

import { useData } from '@shared/api/hooks/useData';
import { FrequentPassageRequestDataTable } from '@shared/frequent-passage-requests/components/FrequentPassageRequestDataTable';
import { getFrequentPassageRequests } from '@shared/frequent-passage-requests/endpoints/getFrequentPassageRequest';
import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { Portlet } from '@shared/ui/components/Portlet';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

export function ListFrequentPassageRequests() {
  const event = useEvent();

  const frequentPassageRequests = useData<FrequentPassageRequest>({
    key: 'frequent-passage-requests',
    get: getFrequentPassageRequests,
    query: { filter: { event_id: event.id } },
    defaults: { sort: '-updated_at' },
  });

  return (
    <AdminWrapper
      title="Frequent Passage Requests"
      actions={
        <Button asChild>
          <Link to="/admin/frequent-passage-requests/create">
            <Icon icon="plus" />
            Create
          </Link>
        </Button>
      }
    >
      <Portlet>
        <FrequentPassageRequestDataTable frequentPassageRequests={frequentPassageRequests} />
      </Portlet>
    </AdminWrapper>
  );
}
